var React = require('react');

function NextArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M42 25.7161C42 24.9498 42.8264 24.4683 43.493 24.846L55.4647 31.63C56.1407 32.013 56.1407 32.987 55.4647 33.37L43.493 40.154C42.8264 40.5317 42 40.0502 42 39.2839V34.9722C42 34.42 41.5523 33.9722 41 33.9722H25C24.4477 33.9722 24 33.5245 24 32.9722V32.0278C24 31.4755 24.4477 31.0278 25 31.0278L41 31.0278C41.5523 31.0278 42 30.58 42 30.0278V25.7161Z","fill":"white"}));
}

NextArrow.defaultProps = {"width":"81","height":"65","viewBox":"0 0 81 65","fill":"none"};

module.exports = NextArrow;

NextArrow.default = NextArrow;
